import { helper } from '@ember/component/helper';

type Input = string | number | boolean | Record<string, unknown> | null | undefined;

interface Signature {
  Args: { Positional: [Input] };
  Return: string;
}

export default helper<Signature>(function formatDateString([raw]: [Input]) {
  if (typeof raw !== 'string' || !raw) return '';

  // Handle first 10 characters to extract YYYY-MM-DD
  const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return '';

  const [, yyyy, mm, dd] = m;
  return `${mm}/${dd}/${yyyy}`;
});
